import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                韩国漫画网
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              韩国漫画网致力于为中国读者提供最优质、最全面的韩国漫画在线阅读服务。每日更新，免费畅享高清韩漫。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/school" className="text-sm text-background-400 hover:text-primary-300 transition-colors">
                  校园漫画
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-300 transition-colors">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-primary-300 transition-colors">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-300 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@koreancomic.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-primary-400"></i>
                <span>www.koreancomic.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>每日 00:00 更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 韩国漫画网 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-primary-300 transition-colors text-sm" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-primary-300 transition-colors text-sm" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}